<div id="main-page-wraper" class="main-page-wraper">
  <!--Ejs2 sidebar -->


  <div class=" flex justify-start">



    <app-sidebar [expanded]="sidebarOpen" id="custom-sidebar" style="z-index: 998;"></app-sidebar>

    <!-- <ejs-sidebar id="nav-sidebar" #navside type="Auto" width="300px" [enableGestures]="isMobile"
      style="visibility: hidden" class="hide-scrollbar" [target]="'layout-main-section'"
      (isOpenChange)="onSidebarChanges($event)">
      <app-sidebar></app-sidebar>
    </ejs-sidebar> -->


 
    <div [@expandCollapseSidebarFake]="sidebarOpen" style="width: 300px!important;" *ngIf="!isMobile">

    </div>




    <div class="layout-main-section duration-200 w-full" id="main-content">

      <div @opacity *ngIf="!sidebarOpen && isMobile" (click)="this.closeSidebar()" style="z-index: 997;"
      class="disable-working-area fixed bg-primary-950/80 w-full text-white will-change-auto">
      <div class="w-full h-full flex justify-between items-center">
        <div style="width: 300px!important;  transform: translateX(0); min-width: 300px; max-width: 300px;"></div>
        <div class="flex flex-col text-center w-full">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-auto">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 6l-12 12" />
            <path d="M6 6l12 12" />
          </svg>
          <p>Chiudi</p>
        </div>
      </div>
    </div>

      <app-header></app-header>



      <div id="layout-main-second" class="layout-main-second">

        <router-outlet></router-outlet>

      </div>

      <div class="layout-footer-section">
        <app-footer></app-footer>
      </div>

    </div>

  </div>


</div>